import { render, staticRenderFns } from "./CreateData.vue?vue&type=template&id=cdda2af2&scoped=true"
import script from "./CreateData.vue?vue&type=script&lang=js"
export * from "./CreateData.vue?vue&type=script&lang=js"
import style0 from "./CreateData.vue?vue&type=style&index=0&id=cdda2af2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdda2af2",
  null
  
)

export default component.exports